import { useEffect, useState } from "react";
import { Flex, Select, SelectProps, Spin, Tag } from "antd";
import { useTranslation } from "react-i18next";

import api from "@/apis/customer";
import { debounce } from "lodash";
import { Customer } from "@/types/sales";
import { CellSelectWrap } from "@/pages/Sales/style";
import { PAGE_SIZE } from "@/utils/const";

interface SCurrencySelectProps extends SelectProps {
  orgId?: string;
  onChangeCustomer?: (info: Customer) => void;
  defaultList?: Customer[];
  supplierApi?: string;
}

const SelectCustomer = ({
  orgId,
  onChangeCustomer,
  onChange,
  defaultList = [],
  supplierApi,
  ...props
}: SCurrencySelectProps) => {
  const { t } = useTranslation();

  const [list, setList] = useState<Array<Customer>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);
  const [listLoading, setListLoading] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>("");

  // useEffect(() => {
  //   fetch("", 1);
  // }, []);

  useEffect(() => {
    if (defaultList.length > 0) setList(last => [...last, ...defaultList])
  }, [defaultList])

  const fetch = (keyword: string, current: number) => {    
    setListLoading(true);
    api.list(orgId, {
      body: keyword,
      pagination: { offset: (current - 1) * PAGE_SIZE, take: PAGE_SIZE },
    }, supplierApi)
      .then((res) => {
        if (current === 1) {
          setList(res.body);
        } else {
          setList([...list, ...res.body]);
        }
        setTotal(res.pagination?.size ?? 0);
      })
      .finally(() => {
        setListLoading(false);
      });
  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;
    if (
      currentPage * PAGE_SIZE < total &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight
    ) {
      let page = currentPage + 1;
      fetch(keyword, page);
      setCurrentPage(page);
    }
  };

  const onSearch = debounce((val: string) => {
    setKeyword(val.trim());
    setCurrentPage(1);
    fetch(val, 1);
  }, 500);

  return (
    <CellSelectWrap style={{ flex: 0 }}>
      <Select
        filterOption={false}
        onSearch={onSearch}
        popupMatchSelectWidth={false}
        onDropdownVisibleChange={(open) => {
          if (open) {
            setKeyword("");
            setCurrentPage(1);
            fetch("", 1);
          }
        }}
        onChange={(val, info) => {
          onChange && onChange(val, info);
          onChangeCustomer && onChangeCustomer(info as Customer)
        }}
        style={{ width: "100%" }}
        showSearch
        placeholder={t("sale.plCustomer")}
        fieldNames={{ value: 'id', label: 'code' }}
        optionRender={({ data }) =>
          <Flex style={{ width: '100%' }} align='center' justify='space-between'>
            <div>{data.shortName || data.name1 || data.name2 || data.code}</div>
            <Tag color='blue'>{data.code}</Tag>
          </Flex>
        }
        options={list}
        onPopupScroll={handleScroll}
        dropdownRender={(ele) => (
          <>
            {ele}
            {listLoading && (
              <Flex
                style={{ width: "100%", padding: 10 }}
                justify="center"
                align="center"
              >
                <Spin />
              </Flex>
            )}
          </>
        )}
        {...props}
      />
    </CellSelectWrap>
  );
};

export default SelectCustomer;
